import { Component, computed, Signal, signal, ViewChild, WritableSignal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ModalComponent } from '../../modal/modal.component';

@Component({
  selector: 'app-full-screen-modal',
  imports: [
    ModalComponent,
    TranslateModule
  ],
  templateUrl: './full-screen-modal.component.html',
  styleUrl: './full-screen-modal.component.scss'
})
export class FullScreenModalComponent {

  @ViewChild('modal', { static: false }) modal!: ModalComponent;

  private _mediaList: WritableSignal<string[]> = signal([]);
  protected mediaList: Signal<string[]> = computed(() => this._mediaList());

  protected selectedMedia: WritableSignal<string> = signal('');

  openModal(mediaList: string[], selectedMedia: string) {
    this._mediaList.set(mediaList);
    this.selectedMedia.set(selectedMedia);
    this.modal.buildModal(() => this.handleClose(), 'modal-fullscreen');
  }

  handleConfirm() {
    // let size = this.selectedMedia();
    // if (size) {
    //   this.handleSelectSize.emit(size);
    // }
    this.handleClose()
  }

  private handleClose() {
    this.modal.dismiss();
  }

}
